// Utilidades de accesibilidad compartidas para los diálogos de ngDialog.
"use strict";

const FOCUSABLE_SELECTOR = [
    'a[href]',
    'area[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'iframe',
    'object',
    'embed',
    '[contenteditable]',
    '[tabindex]:not([tabindex="-1"])'
].join(',');

function isVisible(element) {
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
}

function getActiveDialogContent() {
    const dialogs = Array.prototype.slice.call(document.querySelectorAll('.ngdialog-content'));
    const visibleDialogs = dialogs.filter(isVisible);
    return visibleDialogs.length ? visibleDialogs[visibleDialogs.length - 1] : null;
}

function prepareDialog(content) {
    if (!content) {
        return null;
    }

    // Si la plantilla ya declara su propio role="dialog", se usa ese nodo para
    // evitar anunciar dos diálogos anidados al lector de pantalla.
    const innerDialog = content.querySelector('[role="dialog"]');
    if (innerDialog && content.getAttribute('role') === 'dialog') {
        content.removeAttribute('role');
        content.removeAttribute('aria-modal');
    }

    const dialog = innerDialog || content;
    dialog.setAttribute('aria-modal', 'true');
    if (!dialog.hasAttribute('tabindex')) {
        dialog.setAttribute('tabindex', '-1');
    }

    return dialog;
}

function focusDialog($timeout, focusSelector) {
    $timeout(() => {
        const dialog = prepareDialog(getActiveDialogContent());
        if (!dialog) {
            return;
        }

        const target = focusSelector ? dialog.querySelector(focusSelector) : dialog.querySelector(FOCUSABLE_SELECTOR);
        (target || dialog).focus();
    }, 0);
}

/**
 * Abre un ngDialog asegurando semántica modal, foco inicial, retención del foco
 * dentro del diálogo y devolución del foco al control que lo abrió.
 */
function openAccessibleDialog(ngDialog, options, $timeout, focusSelector) {
    const trigger = document.activeElement;
    const dialog = ngDialog.open(options);

    focusDialog($timeout, focusSelector);

    if (dialog && dialog.closePromise) {
        const handleKeydown = (event) => {
            if (event.key !== 'Tab') {
                return;
            }

            const dialogElement = prepareDialog(getActiveDialogContent());
            if (!dialogElement) {
                return;
            }

            const focusable = Array.prototype.slice
                .call(dialogElement.querySelectorAll(FOCUSABLE_SELECTOR))
                .filter(isVisible);

            if (focusable.length === 0) {
                event.preventDefault();
                dialogElement.focus();
                return;
            }

            const first = focusable[0];
            const last = focusable[focusable.length - 1];

            if (event.shiftKey && (document.activeElement === first || document.activeElement === dialogElement)) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        };

        document.addEventListener('keydown', handleKeydown, true);

        const restoreFocus = () => {
            document.removeEventListener('keydown', handleKeydown, true);
            if (trigger && typeof trigger.focus === 'function' && document.body.contains(trigger)) {
                trigger.focus();
            }
        };

        dialog.closePromise.then(restoreFocus, restoreFocus);
    }

    return dialog;
}

export { openAccessibleDialog };
